import { useQuery } from '@tanstack/react-query';
import { getPresentations, getPresentationsByVendor } from '../service/api';
import { Presentation } from '../types';

export const usePresentations = () => {
  return useQuery<Presentation[]>({
    queryKey: ['presentations'],
    queryFn: getPresentations,
    staleTime: 5 * 60 * 1000
  });
};

export const usePresentationsByVendor = (vendorId: string) => {
  return useQuery<Presentation[]>({
    queryKey: ['presentations', 'vendor', vendorId],
    queryFn: () => getPresentationsByVendor(vendorId),
    enabled: !!vendorId,
    staleTime: 5 * 60 * 1000
  });
};
